export default __webpack_public_path__ + "static/media/titulo_chile.ea6613c8.png";